import {storage} from '@treatwell/ui';
import {ProposedService} from '../../server/routes/availability/types';

export function updateLocalStorage(
  venueId: number | null,
  proposedServices: ProposedService[] | null,
) {
  const key = `venue-basket-${venueId}`;

  if (proposedServices === null) {
    storage.local.setItem(key, {
      services: [],
      updated: new Date().getTime(),
    });
    return;
  }

  const outputServices = proposedServices.map((service) => {
    const serviceIdSplit = /[A-Z]+(\d+)/.exec(service.menuItemId);
    const serviceId = serviceIdSplit ? serviceIdSplit[1] : service.menuItemId;

    return {
      fulfillmentType: 'APPOINTMENT',
      serviceId: parseInt(serviceId),
      skus: service.optionIds.map((id) => {
        return {
          choiceId: parseInt(id),
        };
      }),
    };
  });

  storage.local.setItem(key, {
    services: outputServices,
    updated: new Date().getTime(),
  });
}
